import { Box, Spinner, theme } from "@aksara-ui/react";
import React from "react";

const Loading: React.FC = () => {
  return (
    <Box
      display="flex"
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Spinner
        label="Loading..."
        size={30}
        spinnerColor={`${theme.colors.blue07}`}
      />
    </Box>
  );
};

export default Loading;
